import { Route, Routes } from "react-router-dom";
import { Viewer } from "./Viewer";
import { HomeView } from "./home";
import { OutlinerView } from "./outliner";

export const App = () => {
    return (
        <Routes>
            <Route path="/" element={<HomeView />} />
            {/* <Route path="" element={<Navigate to="/Sideboards/Sideboard?menu=true" />} /> */}

            <Route path="Projects" element={<Viewer />}>
                <Route path=":modelName" element={<OutlinerView />} />
            </Route>
        </Routes>
    );
};
